document.addEventListener("DOMContentLoaded", () => {

    const cards = document.querySelectorAll(".wholesale-card");

    cards.forEach((card,index)=>{
      card.style.animationDelay = (index * .12) + "s";
    });

    if(window.matchMedia("(min-width:768px)").matches){

        cards.forEach((card,index)=>{

            card.addEventListener("mouseenter",()=>{
            card.style.zIndex=99;
            });

            card.addEventListener("mouseleave",()=>{
            card.style.zIndex=index+1;
            });

        });

    }

});